var _rect, _circle, _path, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadyDivider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 564,
    height: 12,
    viewBox: "0 0 564 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.38,
    y: 5,
    width: 564,
    height: 2,
    rx: 1,
    fill: "#FA541C",
    fillOpacity: 0.48
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139.168,
    cy: 6,
    r: 6,
    fill: "#FA541C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.168 5H426.668V7H145.168V5Z",
    fill: "#FA541C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 432.668,
    cy: 6,
    r: 6,
    fill: "#FA541C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyDivider);
export default __webpack_public_path__ + "static/media/ready_divider.d484887682b780874f9f2c3dad177cdb.svg";
export { ForwardRef as ReactComponent };